


































import { Component, Vue, Prop } from 'vue-property-decorator';
import { dictionary, DictionaryEntry, DictionaryCategories } from '@/dictionary';

@Component({
  name: 'Todo'
})
export default class Home extends Vue {

  private get dictionary() {
    return dictionary;
  }

  private get missingTranslation() {
      return dictionary.filter(entry => entry.chinese === '').map(entry => `${entry.german}`);
  }

  private get missingPronunication() {
      return dictionary.filter(entry => entry.pronunciation === '').map(entry => `${ entry.id }: ${entry.german} - ${entry.chinese}`);
  }

  private get missingDescription() {
      return dictionary.filter(entry => entry.description === '').map(entry => `${ entry.id }: ${entry.german} - ${entry.chinese}`);
  }

  private get missingImage() {
      return dictionary.filter(entry => entry.image === '').map(entry => `${ entry.id }: ${entry.german} - ${entry.chinese}`);
  }

  private get categories() {
    return DictionaryCategories;
  }

}  

